// API Configuration for Admin App
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH;

export const API_ENDPOINTS = {
  BOOKINGS: `${API_BASE_URL}${API_BASE_PATH}/bookings`,
  UPDATE_STATUS: (reference) => `${API_BASE_URL}${API_BASE_PATH}/bookings/${reference}/status`,
  UPDATE_PAYMENT_STATUS: (reference) => `${API_BASE_URL}${API_BASE_PATH}/bookings/${reference}/payment-status`,
  PACKAGES: `${API_BASE_URL}${API_BASE_PATH}/packages`,
  PACKAGE_BY_ID: (id) => `${API_BASE_URL}${API_BASE_PATH}/packages/${id}`,
  PACKAGE_BOOKINGS: (id) => `${API_BASE_URL}${API_BASE_PATH}/packages/${id}/bookings`,
};

export default API_BASE_URL;
